module.exports = __webpack_public_path__ + "static/media/TV.b3e7f27a.png";